import React, { useEffect, useState, useRef } from "react";
import {
  Bell,
  Power,
  RefreshCw,
  Calendar,
  Aperture,
  User,
  HelpCircle,
  Target,
  Award,
  BookOpen,
  CheckCircle,
  Server,
  Activity,
  FileText,
  Link2,
  CheckSquare,
  Clipboard,
} from "react-feather";
import { Link, NavLink } from "react-router-dom";
import { ProfileBg, User11 } from "../../imagepath";
import { signOut } from "../../../lib/auth";
import { getFile } from "../../../lib/file";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../usercontext";

// eslint-disable-next-line react/prop-types
export default function StudentSideBar({
  activeMenu,
  mobileMenu,
  setMobileMenu,
}) {
  const [studentName, setStudentName] = useState("");
  const [nickName, setNickName] = useState("");
  const [avatar, setAvatar] = useState("");
  const { profile } = useAuth();
  const navigate = useNavigate();
  const sidebarRef = useRef(null);

  const handleSignOut = async (e) => {
    const error = await signOut();

    navigate("/login");
  };

  async function GetData() {
    //console.log("SideBarAvatar",profile);

    if (profile) {
      setStudentName(profile.name + " " + profile.surname);
      setNickName(profile.username);
      const avt = await getFile(profile.avatar_url);
      setAvatar(avt.publicUrl);
    }
  }

  useEffect(() => {
    GetData();
    //console.log("Sidebar");
  }, [profile]);

  const hideMobileMenu = () => {
    document.body.classList.remove("menu-opened");
    setMobileMenu(false);
  };
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        document.body.classList.remove("menu-opened");
        setMobileMenu(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [setMobileMenu]);
  return (
    <div className="theiaStickySidebar studentSidebar" ref={sidebarRef}>
      <div className="settings-widget dash-profile mb-3">
        <div className="settings-menu p-0">
          <div className="profile-bg">
            <h5 onClick={hideMobileMenu} style={{ cursor: "pointer" }}></h5>
            <img src={ProfileBg} alt="" />
            <div className="profile-img">
              <Link to="/student/student-profile">
                <img src={avatar ? avatar : User11} alt="" />
              </Link>
            </div>
          </div>
          <div className="profile-group">
            <div className="profile-name text-center">
              <h4>
                <Link to="/student/setting-edit-profile">{studentName}</Link>
              </h4>
              <p>{nickName}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="settings-widget account-settings feather-icon">
        <div className="settings-menu">
          <h3>ACCOUNT SETTINGS</h3>
          <ul>
            <li className="nav-item">
              <NavLink to="/student/student-tasklist">
                <Server size={20} /> Agenda
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/student/student-gradeinmonth">
                <Bell size={20} /> Current Grades
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/student/student-activity">
                <Activity size={20} /> Activities
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/student/student-booklist">
                <BookOpen size={20} /> Reading Books
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/student/student-goal-questions">
                <Target size={20} /> Goal Settings
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink to="/student/student-transkript">
                <Aperture size={20} /> Transcript Planning
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink to="/student/student-personal-questions">
                <HelpCircle size={20} /> Personality Assessment
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/student/student-notes">
                <FileText size={20} /> Notes
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/student/student-checklist">
                <CheckCircle size={20} /> Chek List
              </NavLink>
            </li>
            {/*
            <li className="nav-item">
              <NavLink to="/student/student-desiredcollegelist">
                <User size={20} /> My College List
              </NavLink>
            </li>
            */}
            <li className="nav-item">
              <NavLink to="/student/student-curriculum-table">
                <User size={20} /> Application Calendar
              </NavLink>
            </li>

            {/*}
              <li className="nav-item">
              <NavLink to="/student/student-lessons">
                  <RefreshCw size={20} /> Current Courses
              </NavLink>
            </li>
            */}
            {profile.class === 12 ? (
              <li className="nav-item">
                <NavLink to="/student/student-appcheck">
                  <CheckCircle size={20} /> Application Check
                </NavLink>
              </li>
            ) : (
              ""
            )}
            {/*}
            <li>
              <Link to="/student/student-lessons">
                <Award size={20} /> Current Courses
              </Link>
            </li>
*/}
            <li>
              <Link to="/student/student-mainessay">
                <Award size={20} /> Main Essay
              </Link>
            </li>

            <li>
              <Link to="/student/student-supplementalessay">
                <Clipboard size={20} /> Supplementary Essay
              </Link>
            </li>

            <li>
              <Link to="/student/student-additionalinfo">
                <Award size={20} /> Additional Info
              </Link>
            </li>

            <li>
              <Link to="/student/student-bragsheet">
                <Award size={20} /> Brag Sheet
              </Link>
            </li>
            <li>
              <Link to="/student/student-schedulelist">
                <Calendar size={20} /> Schedule
              </Link>
              <Link to="/student/student-resource">
                <Link2 size={20} /> Resource Center
              </Link>
            </li>
            {/*}
            <li className="nav-item">
              <NavLink to="/student/student-test">
                  <FileText size={20} /> Test
              </NavLink>
            </li>
            */}
            {/*}
            <li>
              <NavLink to="/student/setting-edit-profile">
                  <Settings size={20} /> Edit Profile
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/student/student-lessonlist">
                  <RefreshCw size={20} /> Lesson List
              </NavLink>
            </li>
           
            <li className="nav-item">
              <NavLink onClick={handleSignOut} className="nav-link">
                  <Power size={20} /> Sign Out
              </NavLink>
            </li>
             */}
          </ul>
        </div>
      </div>
    </div>
  );
}
